import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme) => ({
    variantError: {
      backgroundColor: '#d42443',
      color: 'white',
    },
    variantSuccess: {
      backgroundColor: '#579e00',
      color: 'white',
    },
  }),
  // {
  //   name: 'NotifyBar',
  // },
);
